import { TranslationTable } from './feiertage';

export const germanTranslations: TranslationTable = {
  NEUJAHRSTAG: 'Neujahrstag',
  HEILIGEDREIKOENIGE: 'Heilige Drei Könige',
  KARFREITAG: 'Karfreitag',
  OSTERSONNTAG: 'Ostersonntag',
  OSTERMONTAG: 'Ostermontag',
  TAG_DER_ARBEIT: 'Tag der Arbeit',
  CHRISTIHIMMELFAHRT: 'Christi Himmelfahrt',
  PFINGSTSONNTAG: 'Pfingstsonntag',
  PFINGSTMONTAG: 'Pfingstmontag',
  FRONLEICHNAM: 'Fronleichnam',
  MARIAHIMMELFAHRT: 'Mariä Himmelfahrt',
  DEUTSCHEEINHEIT: 'Tag der Deutschen Einheit',
  REFORMATIONSTAG: 'Reformationstag',
  ALLERHEILIGEN: 'Allerheiligen',
  BUBETAG: 'Buß- und Bettag',
  ERSTERWEIHNACHTSFEIERTAG: '1. Weihnachtstag',
  ZWEITERWEIHNACHTSFEIERTAG: '2. Weihnachtstag',
  WELTKINDERTAG: 'Weltkindertag',
  WELTFRAUENTAG: 'Weltfrauentag',
  AUGSBURGER_FRIEDENSFEST: 'Augsburger Friedensfest',
};
